export { ReactComponent as TextAlignCenter } from './svgs/align-text-center.svg';
